
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'
import "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyDsyn2HZMzb6nOENNy0C_1PzTB9qc5frnM",
  authDomain: "thelovebirds-icecream.firebaseapp.com",
  projectId: "thelovebirds-icecream",
  storageBucket: "thelovebirds-icecream.firebasestorage.app",
  messagingSenderId: "662471881287",
  appId: "1:662471881287:web:c0984b857b04a712487762",
  measurementId: "G-M2NFRVX1PL"

};
//init firebase app
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;